import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import BINDatatableRowMeta from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/parameters/bin/BINDatatableRowMeta";
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TBINDataTableData = {
    primaryKey: string | number,
    minRank: string,
    maxRank: string,
    issuerBin: string,
    chk: string,
    panLg: string,  
    processingID: string,
    domain: string,
    region: string,
    tech: string,
    riss: string,
    ciss: string,
    ctn: string,
    usage: string,
    cardIn: string,
    //
    cardUsage: string,
    networkCardType: string,
    domainName: string,
    country: string,
    //
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TBINDataTableData>()

export function getBINDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("minRank",
        {
            id: "minRank",
            header: "Rang Min",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("maxRank",
        {
            id: "maxRank",
            header: "Rang Max",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("issuerBin",
        {
            id: "issuerBin",
            header: "Issuer Bin",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("chk",
        {
            id: "chk",
            header: "CHK",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("panLg",
        {
            id: "panLg",
            header: "Pan Lg",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("processingID",
        {
            id: "processingID",
            header: "Proc ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("domain",
        {
            id: "domain",
            header: "Domaine",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("region",
        {
            id: "region",
            header: "Region",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("tech",
        {
            id: "tech",
            header: "Tech",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("riss",
        {
            id: "riss",
            header: "RISS",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("ciss",
        {
            id: "ciss",
            header: "CISS",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("ctn",
        {
            id: "ctn",
            header: "CTN",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("usage",
        {
            id: "usage",
            header: "Usage",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("cardIn",
        {
            id: "cardIn",
            header: "Card In",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    // *********************************************
    columnHelper.accessor("cardUsage",
        {
            id: "cardUsage",
            header: "Utilisation Carte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("networkCardType",
        {
            id: "networkCardType",
            header: "Type carte reseau",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("domainName",
        {
            id: "domainName",
            header: "Domaine",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("country",
        {
            id: "country",
            header: "Pays",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
